import { Text } from '@betterment/samba-react';

import { PersonalProfile } from './data';
import SidebarButton from './SidebarButton';

const ProfileMenu = ({ personalProfile }: { personalProfile: PersonalProfile }) => (
  <SidebarButton label="Profile Menu">
    <Text color="text.onPrimary" variant="text50" css={{ fontWeight: 'medium' }}>
      {personalProfile.firstName}
    </Text>
    <Text variant="text25" color="text.onPrimary">
      {personalProfile.jobTitle}
    </Text>
  </SidebarButton>
);

export default ProfileMenu;
